import { mapState } from 'vuex'
import Cookies from 'js-cookie'

export default {
  computed: {
    ...mapState('experience', {
      exExperience: (state) => ({
        uuid: state.experience.uuid,
        type: state.experience.type,
      }),
    }),
  },
  methods: {
    async handleClickWhatsapp() {
      const params = {
        currency: this.currency,
        event_id: `${this.deviceId}-${Date.now()}`,
        content_type: 'destination',
        content_ids: this.exExperience.uuid
          ? [this.exExperience.uuid]
          : [] /** specific to the top 3-5 destinations listed in search results */,
      }

      const conversion = {
        type: 'WhatsAppLead',
        source_url: window.location.href,
        cookies: {
          _fbp: Cookies.get('_fbp') || '',
          _fbc: Cookies.get('_fbc') || '',
        },
        params: this.$route.query || {},
      }

      await this.$axios.post(
        `/api/conversion/${this.isAuth ? 'user' : 'guest'}`,
        { ...params, ...conversion }
      )

      /** Sending event to Facebook */
      if (typeof this.$fb !== 'undefined') {
        this.$fb.trackCustom('WhatsAppLead', {
          event_category: 'whatsapp-load',
          event_label: 'Click on WhatsApp CTA',
          content_type: 'destination',
          content_ids: this.exExperience.uuid
            ? [this.exExperience.uuid]
            : [] /** specific to the top 3-5 destinations listed in search results */,
        })
      }

      /** Sending event to Google Analytics */
      if (typeof this.$gtag !== 'undefined') {
        this.$gtag('event', 'whatsapp_lead', {
          event_category: 'whatsapp-load',
          event_label: 'Click on WhatsApp CTA',
          page_title: this.$metaInfo.title,
          page_location: window.location.href,
        })

        this.$gtag('event', 'conversion', {
          send_to: `${process.env.GA_AW_CONVERSION_ID}/fc2ECPXXw4QYEPis6vso`,
          value: 1.0,
          currency: this.currency,
        })
      }

      /** Sending event to TikTok */
      if (typeof this.$tiktok !== 'undefined') {
        this.$tiktok.track('WhatsappLead', {
          currency: this.currency,
          contents: [
            {
              content_id: this.exExperience.uuid,
              content_type: this.exExperience.type,
              content_name: this.name,
              content_brand: this.isLad ? 'localadventures' : 'third party',
            },
          ],
        })
      }
    },
    async handleClickAskQuestion() {
      await this.$store.dispatch('modals/toggle', 'askQuestion')
    },
  },
}
